import {
  SET_FILE_LOGS_DATA,
  SET_FILE_LOGS_LOADING,
  SHOW_BATCH_FILE_UPLOAD_MODAL,
  HIDE_BATCH_FILE_UPLOAD_MODAL,
  SET_BATCH_FILE_UPLOAD_LOADING,
  SET_BATCH_FILE_UPLOAD_DATA,
  UPDATE_PAGINATION,
  SET_JOB_QUEUE_LOADING_STATE,
  SET_JOB_QUEUE_DATA,
  SET_PAGE,
  UPDATE_JOB_QUEUE_DATA,
  RESET_SEARCH_VALUE,
  RESET_FILTER_FIELD,
} from './mutation-types';
import {axiosClient} from '../../../core/services/http.service';
import eventBus, {
  ON_MONITORING_FILE_LOGS_GET,
} from '../../../core/services/event-bus';
import moment from 'moment';
import {cloneDeep} from 'lodash-es';

export async function getBatchData({commit}) {
  commit(SET_FILE_LOGS_LOADING, true);
  const {success, body} = await axiosClient.get('/api/FileLoaderLogs');

  const params = {
    batchFileLogs: body.batchFileLogs.sort(function (a, b) {
      return parseFloat(b.BatchFileUploadId) - parseFloat(a.BatchFileUploadId);
    }),
    batchLogs: body.batchLogs.sort(function (a, b) {
      return parseFloat(b.BatchUploadId) - parseFloat(a.BatchUploadId);
    }),
  };


  commit(SET_FILE_LOGS_LOADING, false);
  if (success) {
    commit(SET_FILE_LOGS_DATA, params);
  }
}

export async function showBatchFileUploadModal({commit}) {
  commit(SHOW_BATCH_FILE_UPLOAD_MODAL);
}

export function hideBatchFileUploadModal({commit}) {
  commit(HIDE_BATCH_FILE_UPLOAD_MODAL);
}

export async function getBatchFileUploadData({commit}, id) {
  commit(SET_BATCH_FILE_UPLOAD_LOADING, true);
  const {success, body} = await axiosClient.get(`/api/FileLoaderLogs/${id}/UploadDetail`);
  commit(SET_BATCH_FILE_UPLOAD_LOADING, false);


  if (success) {
    commit(SET_BATCH_FILE_UPLOAD_DATA, {data: body.UploadRecordsResult, id});
  }

  eventBus.$emit(ON_MONITORING_FILE_LOGS_GET, {
    isData: true,
  });
}

export function changePaginationData({commit}, data) {
  commit(UPDATE_PAGINATION, {data});
}

/*--------------------------------------------------------------*/

/* Actions for jobQueue module */

// Function to set the Job Queue loading state
export const setJobQueueLoading = ({commit}) => {
  commit(SET_JOB_QUEUE_LOADING_STATE, true);
};

// Function to fetch Job Queue data and commit it to the store
export const getJobQueueData = async ({commit}) => {
  const {success, body} = await axiosClient.get('/api/AtlasJobQueue/');
  if (success && body.length > 0) {
    const selectedFields = ['jobId', 'predecessorJobId', 'parentJobId', 'status', 'operationKey', 'operationCategory', 'description', 'createdDateTime', 'startedDateTime', 'isBlocked', 'isCancelled'];
    const formattedJobs = body.map(job => {
      return selectedFields.reduce((obj, key) => {
        obj[key] = ['createdDateTime', 'startedDateTime'].includes(key)
          ? job[key] 
            ? moment(job[key]).format('YYYY-MM-DD HH:mm:ss') 
            : ''
          : job[key];
        return obj;
      }, {});
    });
    commit(SET_JOB_QUEUE_DATA, formattedJobs);
  } else {
    commit(SET_JOB_QUEUE_DATA, null);
  }
  commit(SET_JOB_QUEUE_LOADING_STATE, false);
  commit(SET_PAGE, {currentPage: 1, perPage: 10});
};

// Function to cancel a job and refresh the Job Queue data
export const cancelJob = async ({commit}, id) => {
  const {success} = await axiosClient.get(`/api/AtlasJobQueue/${id}/cancel`);
  if (success) {
    await getJobQueueData({commit});
  }
};

// Function to filter the Job Queue data by filter key and search value
export const updateTableByFilter = ({commit, state}) => {
  const copyTableData = cloneDeep(state.jobQueue.data);
  const filterField = state.jobQueue.filterField;
  const searchValue = state.jobQueue.searchValue;

  let filteredTableData = copyTableData;

  if (['createdDateTime', 'startedDateTime'].includes(filterField)) {
    // Date filtering
    filteredTableData = copyTableData.filter(item => {
      const itemDate = parseDateTime(item[filterField]);
      if (!itemDate) return false;
      if (searchValue && typeof searchValue === 'object') {
        const { from, to } = searchValue;
        return (!from || itemDate >= from) && (!to || itemDate <= to);
      }
      return true;
    });
  } else {
    // Text/boolean filtering
    filteredTableData = copyTableData.filter(item => {
      const rawValue = item[filterField];
      const fieldValue = rawValue !== null 
        ? (typeof rawValue === 'boolean' ? String(rawValue).toLowerCase() : rawValue.toLowerCase())
        : '';
      const search = typeof searchValue === 'string' ? searchValue.toLowerCase() : '';
      return fieldValue.includes(search);
    });
  }

  commit(UPDATE_JOB_QUEUE_DATA, filteredTableData);
  commit(SET_PAGE, {currentPage: 1, perPage: 10});
};

// Helper function to parse datetime strings into Date objects
function parseDateTime(dateTimeStr) {
  if (!dateTimeStr) return null;
  const date = new Date(dateTimeStr.replace(' ', 'T'));
  return isNaN(date.getTime()) ? null : date;
}

// Function to reset Job Queue data filter and clear the filter and search value
export const clearFilter = ({commit, state}) => {
  commit(SET_PAGE, {currentPage: 1, perPage: 10});
  commit(UPDATE_JOB_QUEUE_DATA, null);
  commit(RESET_SEARCH_VALUE, '');
  commit(RESET_FILTER_FIELD, null);
};

/*--------------------------------------------------------------*/